var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 28 29",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 21.7503C9.85833 21.7503 9.30903 21.5137 8.85208 21.0404C8.39514 20.5672 8.16667 19.9982 8.16667 19.3337V4.83366C8.16667 4.16908 8.39514 3.60015 8.85208 3.12689C9.30903 2.65362 9.85833 2.41699 10.5 2.41699H21C21.6417 2.41699 22.191 2.65362 22.6479 3.12689C23.1049 3.60015 23.3333 4.16908 23.3333 4.83366V19.3337C23.3333 19.9982 23.1049 20.5672 22.6479 21.0404C22.191 21.5137 21.6417 21.7503 21 21.7503H10.5ZM10.5 19.3337H21V4.83366H10.5V19.3337ZM5.83333 26.5837C5.19167 26.5837 4.64236 26.347 4.18542 25.8738C3.72847 25.4005 3.5 24.8316 3.5 24.167V7.25033H5.83333V24.167H18.6667V26.5837H5.83333Z",
    fill: "#66309D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/Copy.9cfb86fc3227abe33fac551b1c43da69.svg";
export { ForwardRef as ReactComponent };